export const Types = {
  updateModalWelcome: 'dashboard/UPDATE_MODAL_WELCOME',
  getDashboard: 'dashboard/GET_DASHBOARD',
  updateDashboard: 'dashboard/UPDATE_DASHBOARD'
}

export function updateModalWelcome ({ welcomeData } = {}) {
  return {
    type: Types.updateModalWelcome,
    payload: { welcomeData }
  }
}

export function getDashboard ({ campaignId, storeId } = {}) {
  return {
    type: Types.getDashboard,
    payload: { campaignId, storeId }
  }
}

export function updateDashboard ({ dashboardData = {}, error } = {}) {
  return {
    type: Types.updateDashboard,
    payload: { dashboardData, error }
  }
}
